/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetAddressResponseDto
 */
export interface GetAddressResponseDto {
    /**
     * Address unique identifier
     * @type {string}
     * @memberof GetAddressResponseDto
     */
    'id': string;
    /**
     * User ID who owns this address
     * @type {string}
     * @memberof GetAddressResponseDto
     */
    'userId': string;
    /**
     * Address name/label
     * @type {string}
     * @memberof GetAddressResponseDto
     */
    'name': string;
    /**
     * Contact number for this address
     * @type {string}
     * @memberof GetAddressResponseDto
     */
    'contactNumber': string;
    /**
     * Address type
     * @type {string}
     * @memberof GetAddressResponseDto
     */
    'type': GetAddressResponseDtoTypeEnum;
    /**
     * Country name
     * @type {string}
     * @memberof GetAddressResponseDto
     */
    'country': string;
    /**
     * Country code
     * @type {string}
     * @memberof GetAddressResponseDto
     */
    'countryCode': string;
    /**
     * Province name
     * @type {string}
     * @memberof GetAddressResponseDto
     */
    'province': string;
    /**
     * Province code
     * @type {string}
     * @memberof GetAddressResponseDto
     */
    'provinceCode': string;
    /**
     * City name
     * @type {string}
     * @memberof GetAddressResponseDto
     */
    'city'?: string;
    /**
     * City code
     * @type {string}
     * @memberof GetAddressResponseDto
     */
    'cityCode'?: string;
    /**
     * Barangay name
     * @type {string}
     * @memberof GetAddressResponseDto
     */
    'barangay'?: string;
    /**
     * Barangay code
     * @type {string}
     * @memberof GetAddressResponseDto
     */
    'barangayCode'?: string;
    /**
     * Street address
     * @type {string}
     * @memberof GetAddressResponseDto
     */
    'street'?: string;
    /**
     * Additional address line (apartment, unit, floor, building)
     * @type {string}
     * @memberof GetAddressResponseDto
     */
    'addressLine2'?: string;
    /**
     * Postal code
     * @type {string}
     * @memberof GetAddressResponseDto
     */
    'postalCode'?: string;
    /**
     * Source API for address data
     * @type {string}
     * @memberof GetAddressResponseDto
     */
    'sourceApi'?: GetAddressResponseDtoSourceApiEnum;
    /**
     * Full formatted address
     * @type {string}
     * @memberof GetAddressResponseDto
     */
    'fullAddress'?: string;
}

export const GetAddressResponseDtoTypeEnum = {
    Home: 'home',
    Work: 'work',
    Shipping: 'shipping'
} as const;

export type GetAddressResponseDtoTypeEnum = typeof GetAddressResponseDtoTypeEnum[keyof typeof GetAddressResponseDtoTypeEnum];
export const GetAddressResponseDtoSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type GetAddressResponseDtoSourceApiEnum = typeof GetAddressResponseDtoSourceApiEnum[keyof typeof GetAddressResponseDtoSourceApiEnum];


